export default __webpack_public_path__ + "static/body-bg-75163e67f04c506397c3885b6dcce035.webp";